/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import LocalMoviesIcon from "@material-ui/icons/LocalMovies";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import AddIcon from "@material-ui/icons/Add";
import ReceiptIcon from "@material-ui/icons/Receipt";
import PeopleOutlineIcon from "@material-ui/icons/PeopleOutline";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import ContactSupportIcon from "@material-ui/icons/ContactSupport";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import BusinessIcon from "@material-ui/icons/Business";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import PhotoLibraryIcon from "@material-ui/icons/PhotoLibrary";
import TouchAppIcon from "@material-ui/icons/TouchApp";
import CategoryIcon from "@material-ui/icons/Category";
import CardGiftcardIcon from "@material-ui/icons/CardGiftcard";
import { shallowEqual, useSelector } from "react-redux";
import { getTemplateEscapeRooms, getSharedEscapeRooms } from "../../../../../api/escape-room";
import { getAdminMenuBadges } from "../../../../../api/user";
import {
	AsideMenuBadgeGroup,
	AsideMenuCountBadge,
	formatAsideMenuBadgeCount,
} from "./AsideMenuBadges";

const ADMIN_MENU_BADGES_POLL_MS = 60_000;

export function AsideMenuList({ layoutProps }) {
	const user = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);
	const isModerator = user?.role === "moderator" ? true : false;
	const isAdmin = user?.role === "admin";
	const location = useLocation();
	const [escapeRooms, setEscapeRooms] = useState([]);
	const [menuBadges, setMenuBadges] = useState({
		portalUsers: 0,
		supportUnread: 0,
		supportPriorityUnread: 0,
		contactFormUnread: 0,
	});

	useEffect(() => {
		if (!isAdmin) {
			setMenuBadges({
				portalUsers: 0,
				supportUnread: 0,
				supportPriorityUnread: 0,
				contactFormUnread: 0,
			});
			return undefined;
		}

		let cancelled = false;
		let intervalId = null;

		const loadBadges = () => {
			getAdminMenuBadges()
				.then((res) => {
					if (cancelled) return;
					if (res?.status === 200 && res.data) {
						setMenuBadges({
							portalUsers: Number(res.data.portalUsers) || 0,
							supportUnread: Number(res.data.supportUnread) || 0,
							supportPriorityUnread: Number(res.data.supportPriorityUnread) || 0,
							contactFormUnread: Number(res.data.contactFormUnread) || 0,
						});
					}
				})
				.catch(() => {});
		};

		loadBadges();
		intervalId = window.setInterval(loadBadges, ADMIN_MENU_BADGES_POLL_MS);

		return () => {
			cancelled = true;
			if (intervalId) window.clearInterval(intervalId);
		};
	}, [isAdmin, location.pathname]);

	useEffect(() => {
		let cancelled = false;
		if (!isModerator && user) {
			Promise.all([getTemplateEscapeRooms(), getSharedEscapeRooms()])
				.then(([templatesRes, sharedRes]) => {
					if (cancelled) return;
					const templates =
						templatesRes.status === 200 && Array.isArray(templatesRes.data)
							? templatesRes.data
							: [];
					const shared =
						sharedRes.status === 200 && Array.isArray(sharedRes.data)
							? sharedRes.data
							: [];
					const byId = new Map();
					for (const er of [...templates, ...shared]) {
						if (er && er._id != null) byId.set(String(er._id), er);
					}
					const merged = Array.from(byId.values()).sort((a, b) =>
						String(a.name || "").localeCompare(String(b.name || ""), "es", {
							sensitivity: "base",
						})
					);
					setEscapeRooms(merged);
				})
				.catch(() => {
					if (!cancelled) setEscapeRooms([]);
				});
		} else {
			setEscapeRooms([]);
		}
		return () => {
			cancelled = true;
		};
	}, [isModerator, user, location.pathname]);
	const getMenuItemActive = (url, hasSubmenu = false) => {
		return checkIsActive(location, url)
			? ` ${!hasSubmenu &&
					"menu-item-active"} menu-item-open menu-item-not-hightlighted`
			: "";
	};

	return (
		<>
			{/* begin::Menu Nav */}
			<ul className={`menu-nav ${layoutProps.ulClasses}`}>
				{/*begin::1 Level*/}
				<li
					className={`menu-item ${getMenuItemActive(
						"/dashboard",
						false
					)}`}
					aria-haspopup="true"
				>
					<NavLink className="menu-link" to="/dashboard">
						<span className="svg-icon menu-icon">
							<SVG
								src={toAbsoluteUrl(
									"/media/svg/icons/Design/Layers.svg"
								)}
							/>
						</span>
						<span className="menu-text">Dashboard</span>
					</NavLink>
				</li>
				{isModerator && (
					<li className="menu-section">
						<h4 className="menu-text">{"Game"}</h4>
						<i className="menu-icon ki ki-bold-more-hor icon-md"></i>
					</li>
				)}
				{!isModerator && (
					<>
						<li className="menu-section">
							<h4 className="menu-text">PORTAL</h4>
							<i className="menu-icon ki ki-bold-more-hor icon-md"></i>
						</li>
						<li
							className={`menu-item ${getMenuItemActive(
								"/plan-logs",
								false
							)}`}
							aria-haspopup="true"
						>
							<NavLink className="menu-link" to="/plan-logs">
								<span className="menu-icon">
									<ReceiptIcon />
								</span>
								<span className="menu-text">Logs planes</span>
							</NavLink>
						</li>
						{isAdmin ? (
							<li
								className={`menu-item ${getMenuItemActive(
									"/plans-admin",
									false
								)}`}
								aria-haspopup="true"
							>
								<NavLink className="menu-link" to="/plans-admin">
									<span className="menu-icon">
										<LocalOfferIcon />
									</span>
									<span className="menu-text">Planes</span>
								</NavLink>
							</li>
						) : null}
						{isAdmin ? (
							<li
								className={`menu-item ${getMenuItemActive(
									"/portal-users",
									false
								)}`}
								aria-haspopup="true"
							>
								<NavLink className="menu-link" to="/portal-users">
									<span className="menu-icon">
										<PeopleOutlineIcon />
									</span>
									<span className="menu-text">Usuarios portal</span>
									<AsideMenuBadgeGroup>
										<span
											className="aside-menu-badge aside-menu-badge--info"
											title="Usuarios del portal"
										>
											{formatAsideMenuBadgeCount(menuBadges.portalUsers)}
										</span>
									</AsideMenuBadgeGroup>
								</NavLink>
							</li>
						) : null}
						{isAdmin ? (
							<li
								className={`menu-item ${getMenuItemActive(
									"/support-messages",
									false
								)}`}
								aria-haspopup="true"
							>
								<NavLink className="menu-link" to="/support-messages">
									<span className="menu-icon">
										<ContactSupportIcon />
									</span>
									<span className="menu-text">Mensajes soporte</span>
									<AsideMenuBadgeGroup>
										<AsideMenuCountBadge
											count={menuBadges.supportUnread}
											variant="alert"
											title="Mensajes sin leer"
										/>
										<AsideMenuCountBadge
											count={menuBadges.supportPriorityUnread}
											variant="priority"
											title="Mensajes prioritarios sin leer"
										/>
									</AsideMenuBadgeGroup>
								</NavLink>
							</li>
						) : null}

						{isAdmin ? (
							<>
								<li className="menu-section">
									<h4 className="menu-text">GESTIÓN WEB</h4>
									<i className="menu-icon ki ki-bold-more-hor icon-md"></i>
								</li>
								<li
									className={`menu-item ${getMenuItemActive(
										"/blog-posts",
										false
									)} ${getMenuItemActive("/edit-blog-post", false)}`}
									aria-haspopup="true"
								>
									<NavLink className="menu-link" to="/blog-posts">
										<span className="menu-icon">
											<LibraryBooksIcon />
										</span>
										<span className="menu-text">Blog</span>
									</NavLink>
								</li>
								<li
									className={`menu-item ${getMenuItemActive("/promo-faqs", false)} ${getMenuItemActive(
										"/edit-promo-faq",
										false
									)}`}
									aria-haspopup="true"
								>
									<NavLink className="menu-link" to="/promo-faqs">
										<span className="menu-icon">
											<HelpOutlineIcon />
										</span>
										<span className="menu-text">FAQs web</span>
									</NavLink>
								</li>
								<li
									className={`menu-item ${getMenuItemActive(
										"/promo-portfolio-projects",
										false
									)} ${getMenuItemActive("/edit-promo-portfolio-project", false)} ${getMenuItemActive(
										"/promo-portfolio-sectors",
										false
									)} ${getMenuItemActive("/edit-promo-portfolio-sector", false)}`}
									aria-haspopup="true"
								>
									<NavLink className="menu-link" to="/promo-portfolio-projects">
										<span className="menu-icon">
											<PhotoLibraryIcon />
										</span>
										<span className="menu-text">Portfolio web</span>
									</NavLink>
								</li>
								<li
									className={`menu-item ${getMenuItemActive(
										"/promo-clients",
										false
									)} ${getMenuItemActive("/edit-promo-client", false)} ${getMenuItemActive(
										"/promo-client-sectors",
										false
									)} ${getMenuItemActive("/edit-promo-client-sector", false)}`}
									aria-haspopup="true"
								>
									<NavLink className="menu-link" to="/promo-clients">
										<span className="menu-icon">
											<BusinessIcon />
										</span>
										<span className="menu-text">Clientes web</span>
									</NavLink>
								</li>
								<li
									className={`menu-item ${getMenuItemActive(
										"/contact-form-messages",
										false
									)}`}
									aria-haspopup="true"
								>
									<NavLink className="menu-link" to="/contact-form-messages">
										<span className="menu-icon">
											<MailOutlineIcon />
										</span>
										<span className="menu-text">Formularios contacto</span>
										<AsideMenuBadgeGroup>
											<AsideMenuCountBadge
												count={menuBadges.contactFormUnread}
												variant="alert"
												title="Formularios sin leer"
											/>
										</AsideMenuBadgeGroup>
									</NavLink>
								</li>
								<li
									className={`menu-item ${getMenuItemActive(
										"/box-invites",
										false
									)}`}
									aria-haspopup="true"
								>
									<NavLink className="menu-link" to="/box-invites">
										<span className="menu-icon">
											<CardGiftcardIcon />
										</span>
										<span className="menu-text">Cajas fuerte</span>
									</NavLink>
								</li>
							</>
						) : null}

						<li
							className={`menu-item ${getMenuItemActive(
								"/admins",
								false
							)} ${getMenuItemActive("/edit-admin", false)}`}
							aria-haspopup="true"
						>
							<NavLink className="menu-link" to="/admins">
								<span className="menu-icon">
									<AssignmentIndIcon />
								</span>
								<span className="menu-text">
									Administrators
								</span>
							</NavLink>
						</li>

						{!isModerator ? (
							<>
								<li className="menu-section">
									<h4 className="menu-text">PLANTILLAS</h4>
									<i className="menu-icon ki ki-bold-more-hor icon-md"></i>
								</li>
								<li
									className={`menu-item ${getMenuItemActive(
										"/escape-rooms/new",
										false
									)}`}
									aria-haspopup="true"
								>
									<NavLink className="menu-link" to="/escape-rooms/new">
										<span className="menu-icon">
											<AddIcon />
										</span>
										<span className="menu-text">Nueva plantilla</span>
									</NavLink>
								</li>
								<li
									className={`menu-item ${getMenuItemActive(
										"/escape-rooms/button-catalog",
										false
									)}`}
									aria-haspopup="true"
								>
									<NavLink className="menu-link" to="/escape-rooms/button-catalog">
										<span className="menu-icon">
											<TouchAppIcon />
										</span>
										<span className="menu-text">Catálogo de botones</span>
									</NavLink>
								</li>
								<li
									className={`menu-item ${getMenuItemActive(
										"/escape-rooms/template-types",
										false
									)}`}
									aria-haspopup="true"
								>
									<NavLink className="menu-link" to="/escape-rooms/template-types">
										<span className="menu-icon">
											<CategoryIcon />
										</span>
										<span className="menu-text">Tipos de plantilla</span>
									</NavLink>
								</li>
								{escapeRooms.map((er) => (
									<li
										key={er._id}
										className={`menu-item ${getMenuItemActive(
											`/escape-rooms/${er._id}`,
											false
										)}`}
										aria-haspopup="true"
									>
										<NavLink
											className="menu-link"
											to={`/escape-rooms/${er._id}`}
										>
											<span className="menu-icon">
												<LocalMoviesIcon />
											</span>
											<span className="menu-text">
												{er.name}
											</span>
										</NavLink>
									</li>
								))}
							</>
						) : null}
					</>
				)}
				{isModerator ? (
					<li
						className={`menu-item ${getMenuItemActive(
							"/ranking-game",
							false
						)}`}
						aria-haspopup="true"
					>
						<NavLink
							className="menu-link"
							to={`/ranking-game/${user?.game}`}
						>
							<span className="menu-icon">
								<EmojiEventsIcon />
							</span>
							<span className="menu-text">Ranking</span>
						</NavLink>
					</li>
				) : null}

				{/*end::1 Level*/}
			</ul>

			{/* end::Menu Nav */}
		</>
	);
}
